import { useMemo } from "react";

const companyName = "Pt Little Head Hospitality";
const domain = "https://www.bonibeach.com";
const directBookingLink = "https://rm.bonibeach.com/book";
// This guide's own canonical host. Must match the netlify.toml apex (non-www) redirect.
const siteUrl = "https://selong-belanak.com";

const useHotelStructuredData = (ratingValue, reviewCount, headerPhotoUrl) => {
  return useMemo(
    () => ({
      "@context": "https://schema.org",
      "@type": "Hotel",
      name: "Boni Beach Lombok | Hotel & Restaurant",
      address: {
        "@type": "PostalAddress",
        streetAddress: "Jl. Selong Belanak No.1",
        addressLocality: "Selong Belanak",
        addressRegion: "Lombok",
        postalCode: "83572",
        addressCountry: "ID",
      },
      geo: {
        "@type": "GeoCoordinates",
        latitude: "-8.8548",
        longitude: "116.3301",
      },
      telephone: "+62 8113800355",
      email: "info@bonibeach.com",
      url: domain,
      priceRange: "$$$",
      starRating: {
        "@type": "Rating",
        ratingValue,
        bestRating: "5",
      },
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue,
        reviewCount,
      },
      openingHours: "Mo-Su 07:30-21:30",
      amenities: [
        "Free WiFi",
        "Swimming Pool",
        "Restaurant",
        "Bar",
        "Spa",
        "Free Parking",
        "24-hour Front Desk",
        "Air Conditioning",
      ],
      checkinTime: "14:00",
      checkoutTime: "12:00",
      images: [headerPhotoUrl],
      sameAs: [
        "https://www.facebook.com/bonibeachlombok",
        "https://www.instagram.com/bonibeach_lombok/",
        "https://www.tripadvisor.co.id/Hotel_Review-g2147811-d26268502-Reviews-Boni_Beach_Hotel_And_Restaurant-Selong_Belanak_Lombok_West_Nusa_Tenggara.htm",
      ],
      acceptsReservations: "True",
    }),
    [ratingValue, reviewCount, headerPhotoUrl]
  );
};

export { companyName, domain, directBookingLink, siteUrl, useHotelStructuredData };
